import { render, staticRenderFns } from "./GinView.vue?vue&type=template&id=98e2dc62&"
import script from "./GinView.vue?vue&type=script&lang=js&"
export * from "./GinView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports